export const capitalize = (word: string): string => {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
};

export const formatNumber = (number: number): string => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const urlPath = (url: string, proxyname: string): string => {
  return (
    '/asp_net/proxy.aspx?lb://' +
    proxyname +
    url.replace(/^.*\/\/[^/]+:?[0-9]?/i, '')
  );
};

export const tdsUrlPath = (url: string): string => {
  return urlPath(url, 'chaoticmoontds');
};
